module.exports = __webpack_public_path__ + "static/img/1_okinawa.0cc45947.png";